
(function (Drupal) {
  Drupal.behaviors.menuMobile = {
    attach: function (context) {
      window.activeMobileMenu = {}
      once('menuMobileLaunch', '.navigation--mobile .js-toggle-mobile-menu', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          e.preventDefault()
          window.mobileMenu = this.closest('.dropdown')
          //console.log('js-toggle-mobile-menu', window.mobileMenu)
          window.mobileMenu.classList.toggle('active-menu')
        })
      })
      once('menuMobileClick', '.navigation--mobile:not(.navigation--mobile-invest) .dropdown-toggle', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          e.preventDefault()
          var level = this.getAttribute('data-level')
          if (window.activeMobileMenu[level] ) {
            window.activeMobileMenu[level].classList.remove('active-menu')
          }
          window.activeMobileMenu[level] = this.closest('.dropdown')
          //console.log('dropdown-toggle ' + level, window.activeMobileMenu)
          window.activeMobileMenu[level].classList.add('active-menu')
        })
      })

      // invest menu toggles the chevron
      once('menuMobileClick', '.navigation--mobile.navigation--mobile-invest .dropdown-toggle+.chevron', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          e.preventDefault()

          var level = this.getAttribute('data-level')
          //console.log('dropdown-toggle ' + level, el, e)

//          if (window.activeMobileMenu[level] ) {
//            window.activeMobileMenu[level].classList.remove('active-menu')
//          }
          window.activeMobileMenu[level] = this.closest('.dropdown')
          //console.log('dropdown-toggle ' + level, window.activeMobileMenu)
          window.activeMobileMenu[level].classList.toggle('active-menu')
        })
      })


      once('menuMobileClose', '.navigation--mobile .dropdown-close', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          e.preventDefault()
          var level = e.target.getAttribute('data-level')
          window.activeMobileMenu[level] = this.closest('.dropdown')
          console.log('dropdown-close ' + level, window.activeMobileMenu)
          window.activeMobileMenu[level].classList.remove('active-menu')
        })
      })

/*
      once('menuMobileClick', '.navigation--primary .dropdown-toggle', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          const level = e.target.getAttribute('data-level')
          window.activeMobileMenu[level] = e.target.closest('.dropdown')  //.querySelector('.menu.nav') //.find('.dropdown-conte>
          console.log('dropdown-toggle ' + level, window.mobileMenu)
          window.activeMobileMenu[level].classList.toggle('active-menu')
        })
      })
*/

   
      

      /*
      once('menuPrimaryClick', '.navigation--primary .dropbtn', context).forEach(function(el) {
        el.addEventListener('mousedown', function() {
          if (window.currentPrimaryTarget) {
            window.currentPrimaryTarget.classList.remove('active-menu')
          }
          window.currentPrimaryTarget = this.closest('.dropdown')
          window.currentPrimaryTarget.classList.add('active-menu')
        });
      });
      once('menuPrimaryOff', 'html', context).forEach(function(el) {
        el.addEventListener('mousedown', function(e) {
          if (window.currentPrimaryTarget) {
            var dropdown =  e.target.closest('.dropdown')
            if (dropdown != window.currentPrimaryTarget) {
              window.currentPrimaryTarget.classList.remove('active-menu')
              window.currentPrimaryTarget = null
            }
          }
        });
      });
      */
    }
  }
})(Drupal);
